import React, { useState } from 'react';
import { HomePage } from './pages/HomePage';
import { BaselinePage } from './pages/BaselinePage';
import { SamplingPage } from './pages/SamplingPage';
import { TransferPage } from './pages/TransferPage';
import { ScanPage } from './pages/ScanPage';
import { ResultsPage } from './pages/ResultsPage';
export function App() {
  const [currentScreen, setCurrentScreen] = useState('home');
  const showFrame = screen => setCurrentScreen(screen);
  return <div className="min-h-screen bg-gray-50 w-full font-sans" data-id="element-0">
      {currentScreen === 'home' && <HomePage showFrame={showFrame} data-id="element-1" />}
      {currentScreen === 'baseline' && <BaselinePage showFrame={showFrame} data-id="element-2" />}
      {currentScreen === 'sampling' && <SamplingPage showFrame={showFrame} data-id="element-3" />}
      {currentScreen === 'transfer' && <TransferPage showFrame={showFrame} data-id="element-4" />}
      {currentScreen === 'scan' && <ScanPage showFrame={showFrame} data-id="element-5" />}
      {currentScreen === 'results' && <ResultsPage showFrame={showFrame} data-id="element-6" />}
    </div>;
}